import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["block", "children", "className", "disabled", "error", "fullWidth", "mode"];

/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import SelectDown from '@nerdwallet/react-icon/nerdwallet-ui/SelectDown';
import { ActionBlock } from '../ActionBlock/ActionBlock';
import styles from './DropdownTrigger.module.less';
/**
 * Provides the basic structure of the face of a `Select` component.
 *
 * This uses React.forwardRef because multiselect relies on being able to
 * attach a ref to the underlying DOM node.
 */

export var DropdownTrigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames, _classNames2;

  var block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      mode = _ref.mode,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var containerClasses = classNames(styles.container, (_classNames = {}, _defineProperty(_classNames, styles.inline, !block), _defineProperty(_classNames, styles.block, block), _defineProperty(_classNames, styles.fullWidth, block || fullWidth), _classNames));
  var triggerClasses = classNames(className, styles.trigger, styles[mode], (_classNames2 = {}, _defineProperty(_classNames2, styles.disabled, disabled), _defineProperty(_classNames2, styles.fullWidth, block || fullWidth), _classNames2));
  var iconClasses = classNames(styles.icon, _defineProperty({}, styles['icon--disabled'], disabled));
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses,
    ref: ref
  }, /*#__PURE__*/React.createElement(ActionBlock, _extends({}, otherProps, {
    component: mode,
    className: triggerClasses,
    disabled: disabled,
    error: error
  }), children), /*#__PURE__*/React.createElement(SelectDown, {
    className: iconClasses
  }));
});

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  DropdownTrigger.propTypes = {
    block: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    fullWidth: PropTypes.bool,
    mode: PropTypes.oneOf(['select', 'button'])
  };
}

DropdownTrigger.defaultProps = {
  mode: 'select'
};
DropdownTrigger.displayName = 'DropdownTrigger';